import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import { useLocation } from "react-router-dom";
import stl from "./DeskTopBlueMobileWhiteHeader.module.css";
import useHelpers from "@hooks/useHelpers";
import { useRef } from "react";
import { useEffect } from "react";
import useIsMobile from "@hooks/useIsMobile";
import ToggleCarCompare from "@/_MiniApps/CarCompare/Components/ToggleCarCompare";
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
var DeskTopBlueMobileWhiteHeader = function DeskTopBlueMobileWhiteHeader(props) {
  var _props$className;
  var _useTranslation = useTranslation(["web_tracking"]),
    t = _useTranslation.t;
  var location = useLocation();
  var queryParams = new URLSearchParams(location.search);
  var showMyAcc = queryParams.get("showmyAcc");
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var stickyRef = useRef(null); // Create a ref for the sticky element
  var isMobile = useIsMobile();
  var webview = useWebView();
  var isWebView = useIsWebView();
  useEffect(function () {
    webview.showTitleBar(false)["catch"](function () {});
  }, [isWebView]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.BGDiv, props.hideMobile ? "m-hide" : "", props.customBackground ? props.customBackground : "", props.className ? props.className : ""].join(" ")
  }), /*#__PURE__*/React.createElement("div", {
    className: [stl.container, props.hideMobile ? "m-hide" : "", (_props$className = props.className2) !== null && _props$className !== void 0 ? _props$className : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("strong", null, props.title), /*#__PURE__*/React.createElement("div", {
    className: stl.mobileCompare
  }))), (props.hasDeskTopBack || props.hasOnlyMobBack) && /*#__PURE__*/React.createElement("div", {
    ref: stickyRef
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.backtnDT, props.hasOnlyMobBack ? "m-show" : ""].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "container flex justify-between items-center"
  }, +showMyAcc === 1 ? /*#__PURE__*/React.createElement("a", {
    href: createUrl("/user/account")
  }, " ", t("account", {
    ns: "web_tracking"
  })) : /*#__PURE__*/React.createElement("span", {
    onClick: props.onClick ? props.onClick : function () {
      return window.history.go(-1);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/arrow_right.svg",
    alt: "back"
  }), props !== null && props !== void 0 && props.backButtonText ? /*#__PURE__*/React.createElement("span", null, props.backButtonText) : /*#__PURE__*/React.createElement("span", null, t("back", {
    ns: "web_tracking"
  }))), (props === null || props === void 0 ? void 0 : props.showToggle) && !isMobile && /*#__PURE__*/React.createElement(ToggleCarCompare, null)))));
};
export default DeskTopBlueMobileWhiteHeader;